import gsap from 'gsap'
import { FC, useEffect, useRef, useState } from 'react'
import SectionWallpaper3_Full from '../../../assets/SectionWallpaper3_Full.png'
import SectionWallpaper3URL from '../../../assets/SectionWallpaper3.png'
import SectionWallpaper3_1URL from '../../../assets/SectionWallpaper3_1.png'
import SectionWallpaper3_2URL from '../../../assets/SectionWallpaper3_2.png'
import SectionWallpaper3_3URL from '../../../assets/SectionWallpaper3_3.png'
import SectionWallpaper3_4URL from '../../../assets/SectionWallpaper3_4.png'
import ShiningStarURL from '../../../assets/ShiningStarSmall.png'
import { discordUrl } from '../../../common/links'
import { useGSAP } from '@gsap/react'

const CardForm = () => (
  <svg
    width="812"
    height="497"
    viewBox="0 0 812 497"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dddd_3715_2433)">
      <path
        d="M760 73.9129C760 65.5125 753.504 58.5425 745.124 57.9524L69.8814 10.4001C59.6757 9.68138 51.4266 18.5941 52.9315 28.7139L88.09 265.156C89.2031 272.641 95.4083 278.323 102.963 278.774L743.047 316.988C752.242 317.537 760 310.228 760 301.016V73.9129Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dddd_3715_2433"
        x="0.753662"
        y="0.359375"
        width="811.246"
        height="498.657"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="9" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3715_2433"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="32" />
        <feGaussianBlur stdDeviation="16" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3715_2433"
          result="effect2_dropShadow_3715_2433"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="73" />
        <feGaussianBlur stdDeviation="22" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3715_2433"
          result="effect3_dropShadow_3715_2433"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="130" />
        <feGaussianBlur stdDeviation="26" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_3715_2433"
          result="effect4_dropShadow_3715_2433"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect4_dropShadow_3715_2433"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

const CardButtonForm = () => {
  const [isHover, setIsHover] = useState(false)

  return (
    <div className="-ml-[40px]">
      <svg
        width="280"
        height="137"
        viewBox="0 0 280 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M269.372 30.4088C268.475 23.1424 262.462 17.5857 255.148 17.2624L39.9096 7.74842C31.2869 7.36728 24.1222 14.3237 24.2489 22.9538L24.8119 61.3324C24.9297 69.3611 31.3491 75.8732 39.3753 76.106L258.401 82.46C267.586 82.7265 274.849 74.7468 273.723 65.6273L269.372 30.4088Z"
          stroke="#FE902A"
          strokeWidth="2"
          className={`duration-150 ease-in-out ${
            isHover ? 'rotate-3 scale-105 -translate-x-1 -translate-y-2 ' : ''
          }`}
        />
        <g filter="url(#filter0_dddd_3845_2506)">
          <path
            d="M270.365 30.2862C269.407 22.5354 262.994 16.6083 255.192 16.2634L39.9538 6.7494C30.7563 6.34284 23.1139 13.763 23.249 22.9685L23.812 61.347C23.9377 69.911 30.7851 76.8572 39.3463 77.1056L258.372 83.4596C268.169 83.7438 275.917 75.2322 274.715 65.5047L270.365 30.2862Z"
            fill="#FE902A"
            className="cursor-pointer"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            onClick={() => window.open(discordUrl, '_blank')}
          />

          <mask id="mask-circle2">
            <path
              d="M270.365 30.2862C269.407 22.5354 262.994 16.6083 255.192 16.2634L39.9538 6.7494C30.7563 6.34284 23.1139 13.763 23.249 22.9685L23.812 61.347C23.9377 69.911 30.7851 76.8572 39.3463 77.1056L258.372 83.4596C268.169 83.7438 275.917 75.2322 274.715 65.5047L270.365 30.2862Z"
              fill={'white'}
            />
          </mask>
          <circle
            cx="150"
            cy="100"
            r={isHover ? 170 : 0}
            fill="#F27502"
            mask="url(#mask-circle2)"
            className="pointer-events-none max-lg:hidden"
            style={{
              transition: 'r 0.5s ease-in-out',
            }}
          />
        </g>
        <g clipPath="url(#clip0_3845_2506)">
          <path
            d="M68.6751 34.9169C67.1709 34.1621 65.5496 33.5881 63.8458 33.2322C63.8148 33.2254 63.7831 33.2386 63.7661 33.2666C63.5421 33.6342 63.2915 34.1152 63.1145 34.494C61.2806 34.1536 59.4465 34.0896 57.6311 34.3025C57.4813 33.9038 57.256 33.4147 57.0573 33.0323C57.0422 33.0041 57.0115 32.9887 56.9802 32.9924C55.2568 33.2277 53.5994 33.6872 52.0451 34.3362C52.0317 34.3415 52.02 34.3506 52.012 34.3627C48.7403 38.8996 47.7302 43.4012 47.9918 47.891C47.9929 47.9129 48.0045 47.9343 48.0211 47.9482C50.02 49.5265 51.9754 50.5105 53.9046 51.1849C53.9354 51.1955 53.9689 51.1853 53.9897 51.1603C54.473 50.5464 54.9075 49.8964 55.2845 49.2101C55.3067 49.1699 55.2885 49.1206 55.2466 49.103C54.6029 48.8328 53.9923 48.5093 53.4067 48.1459C53.3604 48.1166 53.359 48.0489 53.4036 48.0181C53.5327 47.9282 53.6619 47.8346 53.7854 47.7398C53.8078 47.7225 53.8381 47.7197 53.8633 47.732C57.7261 49.6613 61.9757 49.8097 65.9173 48.1529C65.9433 48.1415 65.9734 48.1464 65.9955 48.1652C66.1121 48.2684 66.2344 48.3717 66.3578 48.4704C66.4001 48.5043 66.3949 48.5718 66.3467 48.5977C65.737 48.9261 65.1056 49.1995 64.4437 49.4232C64.4006 49.4378 64.3799 49.4867 64.3994 49.5283C64.7352 50.2385 65.1233 50.9172 65.5541 51.5631C65.5721 51.5904 65.6057 51.6031 65.6372 51.5946C67.6182 51.0568 69.6375 50.2115 71.7416 48.7765C71.7601 48.7639 71.7721 48.7442 71.7748 48.7224C72.4556 43.5661 71.2747 39.0252 68.7052 34.9466C68.6991 34.933 68.6881 34.9231 68.6751 34.9169ZM56.0031 45.4425C54.8213 45.4012 53.8853 44.2823 53.9319 42.9498C53.9784 41.6173 54.9712 40.5656 56.1719 40.6076C57.382 40.6498 58.3081 41.778 58.243 43.1003C58.1965 44.4328 57.2037 45.4844 56.0031 45.4425ZM63.9729 45.7208C62.7911 45.6795 61.8552 44.5606 61.9018 43.2281C61.9483 41.8956 62.9411 40.844 64.1417 40.8859C65.3519 40.9281 66.278 42.0563 66.2129 43.3786C66.1664 44.7111 65.1831 45.7631 63.9729 45.7208Z"
            fill="white"
            className="pointer-events-none"
          />
        </g>
        <path
          d="M82.183 51.5068L82.584 48.2187C82.9319 48.341 83.3458 48.4655 83.9834 48.4878C85.2806 48.5331 86.0065 47.92 86.0564 46.4909L86.4288 35.8274L89.9906 35.9518L89.6236 46.4614C89.4808 50.5509 87.493 52.0004 84.3929 51.8921C83.5794 51.8637 82.8137 51.7269 82.183 51.5068ZM91.5859 45.8695C91.7126 42.2417 94.3764 39.7151 98.0701 39.8441C101.786 39.9739 104.245 42.6793 104.118 46.3071C103.992 49.9129 101.349 52.4842 97.6333 52.3545C93.9615 52.2263 91.46 49.4753 91.5859 45.8695ZM97.7431 49.2104C99.3041 49.2649 100.487 48.1615 100.55 46.3806C100.609 44.6657 99.4871 43.3937 97.9481 43.34C96.387 43.2855 95.2227 44.4776 95.1628 46.1925C95.1006 47.9734 96.204 49.1566 97.7431 49.2104ZM107.971 39.3313C106.784 39.2899 105.91 38.4669 105.953 37.2356C105.996 36.0044 106.903 35.2436 108.112 35.2858C109.344 35.3288 110.173 36.1503 110.13 37.3815C110.087 38.6127 109.158 39.3728 107.971 39.3313ZM105.821 52.3542L106.238 40.4155L109.646 40.5345L109.229 52.4732L105.821 52.3542ZM111.79 52.5627L112.207 40.624L115.549 40.7407L115.495 42.3017L115.583 42.3048C116.369 41.2096 117.494 40.5224 119.209 40.5823C122.111 40.6836 123.537 42.7146 123.436 45.6169L123.179 52.9604L119.793 52.8422L120 46.9278C120.056 45.3227 119.414 44.1776 117.808 44.1216C116.225 44.0663 115.462 45.1403 115.403 46.8113L115.198 52.6817L111.79 52.5627ZM130.02 47.2116C130.146 43.5838 132.81 41.0572 136.504 41.1862C140.219 41.316 142.679 44.0215 142.552 47.6492C142.426 51.2551 139.783 53.8264 136.067 53.6966C132.395 53.5684 129.894 50.8174 130.02 47.2116ZM136.177 50.5525C137.738 50.607 138.921 49.5037 138.983 47.7227C139.043 46.0078 137.921 44.7358 136.382 44.6821C134.821 44.6276 133.656 45.8197 133.596 47.5346C133.534 49.3156 134.638 50.4988 136.177 50.5525ZM155.775 42.1454L155.358 54.0841L152.016 53.9674L152.068 52.4943L151.98 52.4912C151.239 53.522 150.203 54.1903 148.576 54.1334C145.652 54.0313 144.204 51.9996 144.305 49.0973L144.562 41.7538L147.97 41.8728L147.747 48.2489C147.691 49.8539 148.268 50.9748 149.829 51.0293C151.346 51.0823 152.09 49.9635 152.147 48.3365L152.367 42.0264L155.775 42.1454ZM157.911 54.1732L158.327 42.2345L161.669 42.3512L161.614 43.9342L161.702 43.9373C162.362 42.6836 163.834 42.1406 165.769 42.2082L165.413 46.0921C162.603 45.8839 161.574 46.9707 161.477 49.741L161.318 54.2922L157.911 54.1732ZM172.021 54.666L172.574 38.8356L177.389 39.0038C183.501 39.2172 186.019 42.7832 185.862 47.2685C185.706 51.7318 182.421 55.0292 176.704 54.8295L172.021 54.666ZM177.283 42.6763L176.008 42.6318L175.698 51.4924L176.93 51.5354C180.337 51.6544 182.116 49.8894 182.209 47.229C182.301 44.5906 180.515 42.7892 177.283 42.6763ZM189.755 42.1873C188.568 42.1458 187.694 41.3228 187.737 40.0916C187.78 38.8603 188.687 38.0995 189.896 38.1418C191.128 38.1848 191.958 39.0062 191.915 40.2375C191.872 41.4687 190.942 42.2288 189.755 42.1873ZM187.605 55.2102L188.022 43.2715L191.43 43.3905L191.013 55.3292L187.605 55.2102ZM193.063 54.9385L193.399 52.2426C194.201 52.6008 195.663 52.9601 197.159 53.0123C198.346 53.0537 199.122 52.8827 199.145 52.2231C199.164 51.6954 198.797 51.4845 196.811 50.9749C194.52 50.3886 193.209 49.4843 193.291 47.1537C193.369 44.9111 195.167 43.2348 198.531 43.3523C200.004 43.4037 201.289 43.7788 201.982 44.1112L201.62 47.5326C200.752 47.1941 199.574 46.8888 198.342 46.8458C197.177 46.8051 196.642 47.0066 196.623 47.5562C196.604 48.0839 196.928 48.2713 198.829 48.6679C201.079 49.1647 202.454 50.1373 202.383 52.1601C202.297 54.6446 200.534 55.9479 197.17 55.8304C195.411 55.769 193.994 55.3673 193.063 54.9385ZM212.664 52.6292L212.8 55.6938C211.994 56.0619 210.863 56.3085 209.72 56.2686C205.806 56.132 203.269 53.754 203.408 49.7744C203.538 46.0587 206.023 43.6139 209.981 43.7521C211.19 43.7943 212.346 44.0989 213.168 44.5018L212.785 47.9005C212.094 47.5242 211.266 47.2971 210.298 47.2633C208.275 47.1927 207.046 48.3605 206.985 50.1194C206.922 51.9223 208.114 53.0646 210.071 53.133C210.929 53.1629 211.881 52.9981 212.664 52.6292ZM214.273 50.1538C214.4 46.526 217.063 43.9994 220.757 44.1284C224.473 44.2582 226.932 46.9637 226.805 50.5914C226.679 54.1972 224.036 56.7686 220.32 56.6388C216.648 56.5106 214.147 53.7596 214.273 50.1538ZM220.43 53.4947C221.991 53.5492 223.174 52.4459 223.236 50.6649C223.296 48.95 222.174 47.678 220.635 47.6243C219.074 47.5698 217.91 48.7619 217.85 50.4768C217.788 52.2577 218.891 53.441 220.43 53.4947ZM228.508 56.6386L228.925 44.6998L232.267 44.8165L232.212 46.3996L232.3 46.4026C232.96 45.1489 234.432 44.606 236.367 44.6735L236.011 48.5575C233.2 48.3493 232.172 49.436 232.075 52.2063L231.916 56.7576L228.508 56.6386ZM250.138 40.6637L249.554 57.3735L246.19 57.256L246.241 55.8049L246.175 55.8026C245.435 56.8334 244.07 57.4682 242.443 57.4113C239.255 57.3 236.873 54.9054 237.012 50.9258C237.149 46.9902 239.823 44.7942 242.902 44.9017C244.463 44.9562 245.803 45.6634 246.419 46.9397L246.506 46.9428L246.73 40.5447L250.138 40.6637ZM243.505 48.4229C241.922 48.3677 240.649 49.5119 240.588 51.2709C240.524 53.0957 241.695 54.2373 243.3 54.2934C244.905 54.3494 246.197 53.2938 246.261 51.447C246.326 49.6001 245.11 48.479 243.505 48.4229Z"
          fill="white"
          className="pointer-events-none"
        />
        <defs>
          <filter
            id="filter0_dddd_3845_2506"
            x="-44.7529"
            y="0.733398"
            width="324.591"
            height="135.733"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-3" dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3845_2506"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-12" dy="8" />
            <feGaussianBlur stdDeviation="7" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_3845_2506"
              result="effect2_dropShadow_3845_2506"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-26" dy="17" />
            <feGaussianBlur stdDeviation="9.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_3845_2506"
              result="effect3_dropShadow_3845_2506"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-46" dy="31" />
            <feGaussianBlur stdDeviation="11" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_3845_2506"
              result="effect4_dropShadow_3845_2506"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect4_dropShadow_3845_2506"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_3845_2506">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(48.5229 29.8408) rotate(2)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

const StarSection: FC<{
  delay: number
  dur1: number
  dur2: number
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null)
  const ref2 = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // return
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ repeat: -1 })

      tl.to(ref.current, {
        width: 135,
        height: 135,
        opacity: 1,
        duration: props.dur1,
        delay: props.delay,
        ease: 'none',
      })
      tl.to(ref.current, {
        height: 71,
        width: 71,
        // scale: 0.7,
        opacity: 0,
        duration: props.dur2,
        ease: 'none',
      })

      const tl2 = gsap.timeline({ repeat: -1 })

      tl2.to(ref2.current, {
        rotateZ: '+=180',
        duration: props.dur1 + props.dur2,
        delay: props.delay,
        ease: 'none',
      })
    })

    // Clean up animations on unmount
    return () => ctx.revert()
  }, [])

  return (
    <div ref={ref2} className="mix-blend-color-dodge size-[135px] relative">
      <div
        ref={ref}
        className="absolute left-1/2  -translate-x-1/2 top-1/2 -translate-y-1/2 size-[87px] opacity-0"
      >
        <img className="mix-blend-color-dodge" src={ShiningStarURL} alt="" />
      </div>
    </div>
  )
}

export const Section3 = () => {
  const cardRef = useRef<HTMLDivElement>(null)
  const starsRef = useRef<HTMLDivElement>(null)
  const backgroundImgRef = useRef<HTMLImageElement>(null)
  const gold1ImgRef = useRef<HTMLImageElement>(null)
  const gold2ImgRef = useRef<HTMLImageElement>(null)
  const gold3ImgRef = useRef<HTMLImageElement>(null)
  const playerImgRef = useRef<HTMLImageElement>(null)

  const [startStarsAnimation, setStartStarsAnimation] = useState(false)

  useGSAP(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        scroller: '#scroll-container',
        trigger: backgroundImgRef.current,
        start: '350px center',
        end: '400px 40%',
        scrub: 0.1,
        //markers: true,
        onEnterBack: () => {
          setStartStarsAnimation(false)

          gsap.to(starsRef.current, {
            opacity: 0,
            duration: 0.4,
          })

          gsap.to(cardRef.current, {
            opacity: 0,
            top: 602,
            duration: 0.4,
          })
        },
      },
      onComplete: () => {
        setStartStarsAnimation(true)

        gsap.to(starsRef.current, {
          opacity: 1,
          duration: 0.4,
        })

        gsap.to(cardRef.current, {
          opacity: 1,
          top: 492,
          duration: 0.4,
        })
      },
    })
    tl.to(backgroundImgRef.current, {
      top: 0,
      left: 0,
      width: 1760,
      height: 980,
    })
    tl.to(
      gold1ImgRef.current,
      {
        top: 637,
        left: 0,
        width: 584,
      },
      '<='
    )
    tl.to(
      gold2ImgRef.current,
      {
        top: 747,
        left: 632,
      },
      '<='
    )
    tl.to(
      gold3ImgRef.current,
      {
        top: 685,
        left: 1145,
        width: 615,
      },
      '<='
    )
    tl.to(
      playerImgRef.current,
      {
        top: 120,
        left: 287,
        width: 701,
      },
      '<='
    )
  })

  return (
    <div className="relative h-[980px] rounded-2xl max-lg:rounded-none overflow-hidden">
      <img
        className="hidden max-lg:block  size-full object-cover"
        src={SectionWallpaper3_Full}
        alt=""
      />

      <img
        ref={backgroundImgRef}
        className="max-lg:hidden absolute -top-[114px] -left-[102px] w-[1964px] min-w-[1964px] h-[1094px]"
        src={SectionWallpaper3URL}
        alt=""
      />
      <img
        ref={gold1ImgRef}
        className="max-lg:hidden absolute top-[686px] -left-[102p] w-[616px] "
        src={SectionWallpaper3_1URL}
        alt=""
      />
      <img
        ref={gold2ImgRef}
        className="max-lg:hidden absolute top-[767px] left-[606px] w-[497px] "
        src={SectionWallpaper3_2URL}
        alt=""
      />
      <img
        ref={gold3ImgRef}
        className="max-lg:hidden absolute top-[730px] left-[1163px] w-[667px] "
        src={SectionWallpaper3_3URL}
        alt=""
      />
      <img
        ref={playerImgRef}
        className="max-lg:hidden absolute top-[262px] left-[348px] w-[579px] "
        src={SectionWallpaper3_4URL}
        alt=""
      />
      {/* Content */}
      <div
        ref={cardRef}
        className="opacity-0 max-lg:hidden absolute  right-[120px] top-[602px]"
      >
        <div className="relative">
          <CardForm />
          {/* Card Content */}
          <div className="absolute inset-0 size-full pt-[80px] pl-[150px] 0bg-red-500/50">
            <div className="rotate-2 w-[550px] flex flex-col gap-4 text-right">
              <div className="text-[#0F204B] text-5xl font-bold">
                Player-Run Economy
              </div>
              <div className="text-[18px] text-black font-medium">
                Loot, craft, and level up as you pillage yer way to becoming a
                Pirate Lord! Own yer own ships, pieces of islands, and digital
                collectibles to amass yer fortune!
              </div>
              <div className="grow"></div>
              <CardButtonForm />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="absolute inset-0">
        <StarSection delay={1} dur1={0.8} dur2={0.8} />
        <StarSection delay={1} dur1={0.45} dur2={0.45} />
        <StarSection delay={1} dur1={1.2} dur2={1.2} />
        <StarSection delay={1} dur1={0.9} dur2={0.9} />
      </div> */}

      {/* Stars */}
      <div ref={starsRef} className=" opacity-0 max-lg:hidden">
        {startStarsAnimation && (
          <>
            <div className="absolute left-[1607px] top-[765px]">
              <StarSection delay={1} dur1={0.9} dur2={0.9} />
            </div>
            <div className="absolute left-[784px] top-[817px]">
              <StarSection delay={1} dur1={1.2} dur2={1.2} />
            </div>
            <div className="absolute left-[787px] top-[685px]">
              <StarSection delay={1.5} dur1={0.45} dur2={0.45} />
            </div>
            <div className="absolute left-[1037px] top-[855px]">
              <StarSection delay={1.5} dur1={0.45} dur2={0.45} />
            </div>
            <div className="absolute left-[361px] top-[796px]">
              <StarSection delay={1.5} dur1={0.45} dur2={0.45} />
            </div>
            <div className="absolute left-0 top-[839px]">
              <StarSection delay={1} dur1={0.8} dur2={0.8} />
            </div>
            <div className="absolute left-[89px] top-[698px]">
              <StarSection delay={1} dur1={0.8} dur2={0.8} />
            </div>
          </>
        )}
      </div>

      {/* Mobile Content */}
      <div className="hidden max-lg:block absolute size-full inset-0">
        <div className="px-6 pb-20 size-full flex flex-col justify-end">
          <div className="relative px-6 pt-5 pb-16 flex flex-col gap-4 bg-white rounded-xl ">
            <div className="text-[#0F204B] text-5xl font-bold">
              Player-Run Economy
            </div>
            <div className="text-[18px] text-black font-medium">
              Loot, craft, and level up as you pillage yer way to becoming a
              Pirate Lord! Own yer own ships, pieces of islands, and digital
              collectibles to amass yer fortune!
            </div>
            <div className="absolute -bottom-[90px] right-4">
              <CardButtonForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
